module.exports = __webpack_public_path__ + "img/grow.c2cb091f.png";